<!--推荐配置Ec-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">销帮帮推送配置</div>
    <el-tabs class="tabs-container" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="销帮帮账号配置" name="first">
        <EcAccount></EcAccount>
      </el-tab-pane>
      <el-tab-pane label="模板配置" name="second" lazy=’true’>
        <TempSetting :origin="origin"></TempSetting>
      </el-tab-pane>
      <el-tab-pane label="来源配置" name="third" lazy=’true’>
        <EcOrigin :origin="origin"></EcOrigin>
      </el-tab-pane>
      <el-tab-pane label="字段配置" name="fourth" lazy=’true’>
        <EcField :origin="origin"></EcField>
      </el-tab-pane>
      <el-tab-pane label="消息通知" name="six" lazy=’true’>
        <EcNotice :origin="origin"></EcNotice>
      </el-tab-pane>
      <el-tab-pane label="资源分发规则" name="fifty" lazy=’true’>
        <EcRule :origin="origin"></EcRule>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import EcAccount from '@/components/client/xbb/XbbcrmAccount'
  import TempSetting from '@/components/client/crm/TempSetting'
  import EcOrigin from '@/components/client/crm/EcOrigin'
  import EcField from '@/components/client/crm/EcField'
  import EcRule from '@/components/client/crm/EcRule'
  import EcNotice from '@/components/client/crm/EcNotice'
  export default {
    components: {
      EcAccount,
      TempSetting,
      EcOrigin,
      EcField,
      EcRule,
      EcNotice
    },
    data () {
      return {
        activeName: 'first',
        origin: 'xbb'
      }
    }
  }
</script>
<style lang="scss">
.com-table .el-tabs__nav-wrap:after{
  height:1px;
}
</style>
<style scoped lang="scss">
@import '../../../assets/styles/_env.scss';

/deep/ .tabs-container {
  [aria-controls=pane-fifty] {
    color: $color-gray;
  }
  [aria-controls=pane-fifty]:hover,  [aria-controls=pane-fifty].is-active{
    color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/xbb/XbbcrmSetting.vue